export const MENU_ITEMS = [
  {
    id: 'jobs',
    label: 'Jobs',
    url: 'https://formations.applytojob.com/apply',
  },
  {
    id: 'case-studies',
    label: 'Customer Stories',
    url: 'https://formationscorp.com/case-studies/',
  },
  {
    id: 'blog',
    label: 'Blog',
    url: 'https://formationscorp.com/blog/',
  },
  {
    id: 'about-us',
    label: 'About Us',
    url: 'https://formationscorp.com/about-us/',
  },
];
